<ng-template>
   <div lcsSingleSelectPanel [visible]="isPanelVisible">
      @if (isIncludeEmptyOption) {
      <lcs-option>{{ overrideEmptyOption !== '' ? overrideEmptyOption : '' }}</lcs-option>
      } @for (timeZone of timeZones | async; track trackBy(timeZone)) {
      <lcs-option [value]="timeZone" id="lcs-option-id-{{ timeZone.timeZoneId }}">
         {{ timeZone.timeZoneId }}
      </lcs-option>
      }
   </div>
</ng-template>
